import "react-app-polyfill/stable";
import React, { Suspense } from "react";
import { Redirect } from "react-router-dom";
import ReactDOM from "react-dom";
import "./index.css";

import * as serviceWorker from "./serviceWorker";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Editor from "./components/editor";
import AudioEditor from "./components/audio-components/editor";
import Cart from "./components/cart";
import Completed from "./components/completed";
import ScrollToTop from "react-router-scroll-top";
import Admin from "./components/admin-components/admin";
import Login from "./components/login-components/login";
import Logout from "./components/login-components/logout";
import PromoList from "./components/promo-components/promo-list";
import PromoAdd from "./components/promo-components/promo-add";
import AdminNovaPoshta from "./components/admin-components/admin-novaPoshta";

import Promo from "./components/promo-components/promo";
import BackendLoginService from "./components/login-components/backendLoginService";

import "./i18n";

// import $ from "jquery";
// import Popper from "popper.js";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";

if (process.env.NODE_ENV === "development") {
  console.log("why-did-you render!");
  const whyDidYouRender = require("@welldone-software/why-did-you-render");
  whyDidYouRender(React, {
    trackAllPureComponents: true,
    titleColor: "green",
    diffNameColor: "aqua",
  });
}

function Spinner() {
  return (
    <div className="spinner-host">
      <div className="spinner-middle">
        <div className="spinner"></div>
        <p className="g-mt-10" id="angular_loader">
          Завантаження...
        </p>
      </div>
    </div>
  );
}

let language = "";

try {
  const path = window.location.pathname;
  const pathSplit = path.split("/");

  if (pathSplit && pathSplit.length > 1 && pathSplit[1].length == 2) {
    language = pathSplit[1] + "/";
  }
} catch (e) {
  (console.error || console.log).call(console, e.stack || e);
}
const baseName = "/" + language + "sky";

let isLoggedIn = () => {
  try {
    var isLoggedIn = BackendLoginService.getInstance().isLoggedIn();
    console.log("Index isLoggedIn:", isLoggedIn);
    return isLoggedIn;
  } catch {
    return false;
  }
};

ReactDOM.render(
  //<React.StrictMode>
  <Suspense fallback={<Spinner></Spinner>}>
    <BrowserRouter basename={baseName}>
      <ScrollToTop>
        <div className="cointainer">
          <Switch>
            {/* <Route
              path="/:lang?/sky"
              render={({ match: { url } }) => (
                <>
                  <Route path={`${url}/completed`} component={Completed} />
                  <Route path={`${url}/cart`} component={Cart} exact />
                  <Route path={`${url}/editor`} component={Editor} exact />
                </>
              )}
            /> */}

            <Route path="/completed/:orderId" component={Completed} />
            <Route exact path="/cart" component={Cart} />
            <Route exact path="/editor" component={Editor} />
            <Route exact path="/audio" component={AudioEditor} />
            <Route exact path="/sasha" component={Admin} />
            <Route exact path="/novaposhta" component={AdminNovaPoshta} />
            <Route exact path="/np" component={AdminNovaPoshta} />
            <Route
              exact
              path="/promo"
              render={() => {
                return !isLoggedIn() ? (
                  <Redirect
                    to={{
                      pathname: "/login",
                      state: { from: "/promo" },
                    }}
                  />
                ) : (
                  <PromoList />
                );
              }}
            />
            <Route
              exact
              path="/promo/add"
              render={() => {
                return !isLoggedIn() ? (
                  <Redirect
                    to={{
                      pathname: "/login",
                      state: { from: "/promo/add" },
                    }}
                  />
                ) : (
                  <PromoAdd />
                );
              }}
            />
            <Route
              exact
              path="/promo/edit/:code"
              render={(props) => {
                return !isLoggedIn() ? (
                  <Redirect
                    to={{
                      pathname: "/login",
                      state: { from: "/promo" },
                    }}
                  />
                ) : (
                  <PromoAdd {...props} />
                );
              }}
            />
            {/* <Route exact path="/promo/add2" component={PromoAdd} /> */}
            {/* <Route exact path="/promo" component={PromoList} />
            <Route exact path="/promo/add" component={PromoAdd} />
            <Route exact path="/promo/edit/:code" component={PromoAdd} />
            <Route
              path="/promo2"
              render={() => {
                console.log("Renderring promo route");
                return !isLoggedIn() ? (
                  <Redirect
                    to={{
                      pathname: "/login",
                      state: { from: "/promo2" },
                    }}
                  />
                ) : (
                  <Promo />
                );
              }}
            /> */}

            <Route exact path="/login" component={Login} />
            <Route exact path="/logout" component={Logout} />
          </Switch>
        </div>
      </ScrollToTop>
    </BrowserRouter>
  </Suspense>,
  // </React.StrictMode>
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
